import { createWithEqualityFn as create } from "zustand/traditional";
import { ItemType } from "@jasper/shared";

type CreateCombinedWorkflowOrderStoreState = {
  newCombinedOrderId: string | null;
  combinedWorkflowProducts: ItemType[];
  updateNewCombinedOrderId: (id: string) => void;
  updateCombinedWorkflowProducts: (workflow: ItemType[]) => void;
  resetStore: () => void;
};

export const useCombinedWorkflowOrderStore =
  create<CreateCombinedWorkflowOrderStoreState>()(set => ({
    newCombinedOrderId: null,
    combinedWorkflowProducts: [],
    updateNewCombinedOrderId: (id: string) => set({ newCombinedOrderId: id }),
    updateCombinedWorkflowProducts: (workflow: ItemType[]) =>
      set({ combinedWorkflowProducts: workflow }),
    resetStore: () =>
      set({
        newCombinedOrderId: null,
        combinedWorkflowProducts: [],
      }),
  }));
